// extracted by mini-css-extract-plugin
export var screen = "fx9P+";